import React from "react";
import { TopNav } from "@/components/TopNav";
import { MockEmailModeBanner } from "@/components/MockEmailModeBanner";
import { ImpersonationBanner } from "@/components/ImpersonationBanner";

export function DashboardShell({ children }) {
    return (
        <div className="min-h-screen bg-slate-50">
            <TopNav />
            <ImpersonationBanner />
            <MockEmailModeBanner />
            <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-10">
                {children}
            </main>
        </div>
    );
}
